import { ServiceType } from '../types/api';
import configService from '../services/configService';

/**
 * Helper function to get original price from config service or fallback to hardcoded
 */
export const getOriginalPriceFromConfig = (
  subscriptionType: string,
  subscriptionLevel: string,
  currency: string,
  serviceType: ServiceType,
  originalRegularPricing: any,
  trialOriginalPricing: any
) => {
  if (subscriptionType === 'trial') {
    // Use config service data or fallback to hardcoded
    if (trialOriginalPricing) {
      const levelPricing = trialOriginalPricing[subscriptionLevel as 'standard' | 'premium'];
      return levelPricing?.[currency as 'thb' | 'usd'] || 
        (serviceType === 'flower'
          ? (subscriptionLevel === 'premium' 
            ? (currency === 'usd' ? 7.99 : 249)
            : (currency === 'usd' ? 5.99 : 149))
          : (subscriptionLevel === 'premium'
            ? (currency === 'usd' ? 15.99 : 549)
            : (currency === 'usd' ? 10.99 : 299)));
    } else {
      // Fallback to hardcoded values
      return serviceType === 'flower'
        ? (subscriptionLevel === 'premium' 
          ? (currency === 'usd' ? 7.99 : 249)
          : (currency === 'usd' ? 5.99 : 149))
        : (subscriptionLevel === 'premium'
          ? (currency === 'usd' ? 15.99 : 549)
          : (currency === 'usd' ? 10.99 : 299));
    }
  } else {
    // Use config service data or fallback to hardcoded
    if (originalRegularPricing) {
      const levelPricing = originalRegularPricing[subscriptionLevel as 'standard' | 'premium'];
      return levelPricing?.[currency as 'thb' | 'usd'] || 
        (serviceType === 'flower'
          ? (subscriptionLevel === 'premium' ? (currency === 'usd' ? 24.99 : 699) : (currency === 'usd' ? 19.99 : 499))
          : (subscriptionLevel === 'premium' ? (currency === 'usd' ? 42.99 : 1299) : (currency === 'usd' ? 32.99 : 999)));
    } else {
      // Fallback to hardcoded values
      return serviceType === 'flower'
        ? (subscriptionLevel === 'premium' ? (currency === 'usd' ? 24.99 : 699) : (currency === 'usd' ? 19.99 : 499))
        : (subscriptionLevel === 'premium' ? (currency === 'usd' ? 42.99 : 1299) : (currency === 'usd' ? 32.99 : 999));
    }
  }
};

/**
 * Helper function to get trial price from config service or fallback to hardcoded
 */
export const getTrialPriceFromConfig = (
  subscriptionLevel: string,
  currency: string,
  serviceType: ServiceType
) => {
  // First try to get from configService's trial pricing
  const fetchFromConfig = async () => {
    try {
      const trialPricing = await configService.getTrialPricing(serviceType);
      const levelPricing = trialPricing[subscriptionLevel as 'standard' | 'premium'];
      return levelPricing?.[currency as 'thb' | 'usd'];
    } catch (error) {
      console.error('Error fetching trial pricing:', error);
      return null;
    }
  };

  // Return fallback values - these should match the configService defaults
  const defaultValues = serviceType === 'flower'
    ? (subscriptionLevel === 'premium'
      ? (currency === 'usd' ? 8.99 : 299)
      : (currency === 'usd' ? 5.99 : 199))
    : (subscriptionLevel === 'premium'
      ? (currency === 'usd' ? 13.99 : 449)
      : (currency === 'usd' ? 8.99 : 299));

  // Try to get from config, but return sync fallback for now
  fetchFromConfig().then(value => {
    // This is async but we need sync return for this usage
    // Could be improved with state management if needed
  });

  return defaultValues;
};

/**
 * Helper function to get crypto pricing from config service or fallback to hardcoded
 */
export const getCryptoPriceFromConfig = (
  subscriptionLevel: string,
  serviceType: ServiceType,
  cryptoPricing: any
) => {
  if (cryptoPricing) {
    const levelPricing = cryptoPricing[subscriptionLevel as 'standard' | 'premium'];
    return levelPricing?.usd || 
      (serviceType === 'fruit'
        ? (subscriptionLevel === 'premium' ? 39.99 : 27.99)
        : (subscriptionLevel === 'premium' ? 15.99 : 9.99));
  } else {
    // Fallback to hardcoded values
    return serviceType === 'fruit'
      ? (subscriptionLevel === 'premium' ? 39.99 : 27.99)
      : (subscriptionLevel === 'premium' ? 15.99 : 9.99);
  }
}; 